import PropTypes from 'prop-types';
import organizationMembershipStatusShape from 'shapes/organizationMembershipStatusShape';
import Account from 'modules/Account';
export const organizationMembership = PropTypes.shape({
    identityUID: PropTypes.string.isRequired,
    organizationUID: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool,
    status: organizationMembershipStatusShape.isRequired,
    scope: Account.shapes.scopeName,
    publicKey: PropTypes.string,
    details: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        avatar: PropTypes.string,
        businessEmail: PropTypes.string.isRequired
    })
});
